import AuthenticatedApp from "./AuthenticatedApp";

export default AuthenticatedApp;